// ============================================================
// Competition Module — Router (index.tsx)
// Lazy-loads competition sub-routes under /competition.
// Angular source: CompetitionModule
// ============================================================
import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

const ClubsStateLevelStem = lazy(() => import('./ClubsStateLevelStem'));
const ClubsBlockLevelStem = lazy(() => import('./ClubsBlockLevelStem'));
const ClubsDistrictLevelStem = lazy(() => import('./ClubsDistrictLevelStem'));

const CompetitionModule: React.FC = () => {
  return (
    <Suspense fallback={<div className="text-center p-5">Loading...</div>}>
      <Routes>
        <Route path="club-state-level-stem" element={<ClubsStateLevelStem />} />
        <Route path="club-block-level-stem" element={<ClubsBlockLevelStem />} />
        <Route
          path="club-district-level-stem"
          element={<ClubsDistrictLevelStem />}
        />
      </Routes>
    </Suspense>
  );
};

export default CompetitionModule;
